import React, { useState, useMemo, useContext } from 'react'

import { useSelector } from 'react-redux'
import { Input, Tooltip } from 'antd'
import { isString } from 'lodash'

import { InstitutionContext } from '../../../../Providers/InstitutionProvider'
import { isCtrlKeyPressed } from '../../../../utils'
import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'

const { Search } = Input

const FIRST_OFFSET = 10
const BORDER_RADIUS = 10

const InstitutionSchoolsList = ({ selected = [], onSelect }) => {
  const t = useSelector(selectTranslate)

  const { coloredSchools } = useContext(InstitutionContext)

  const [search, setSearch] = useState('')
  const [selectedSchools, setSelectedSchools] = useState(selected ?? [])

  const filteredSchools = useMemo(() => {
    const lowerCaseSearch = search.toLowerCase()

    return coloredSchools.filter(school =>
      school.name.toLowerCase().includes(lowerCaseSearch) || (isString(school.abbreviation) && school.abbreviation.toLowerCase().includes(lowerCaseSearch))
    )
  }, [coloredSchools, search])

  const handleClick = (e, id) => {
    let schoolIds = []

    if (isCtrlKeyPressed(e)) {
      schoolIds = selectedSchools.includes(id) ? selectedSchools.filter(s => s !== id) : [...selectedSchools, id]
    } else if (!selectedSchools.includes(id) || selectedSchools.length > 1) {
      schoolIds = [id]
    }

    setSelectedSchools(schoolIds)
    onSelect(filteredSchools.filter(s => schoolIds.some(id => s.id === id)))
  }

  const borderRadius = useMemo(() => `0px 0px ${BORDER_RADIUS}px ${BORDER_RADIUS}px`, [])

  return (
    <div style={{ height: '100%' }}>
      <h4><strong>{t('data_table.column_title.school')}</strong></h4>
      <div style={{ height: '100%' }}>
        <Search
          placeholder={t('filter.search')}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ maxWidth: '400px', zIndex: 2 }}
        />
        <div style={{ overflowY: 'scroll', maxHeight: '30em', borderRadius, transform: `translateY(-${FIRST_OFFSET}px)`, zIndex: 1 }}>
          {filteredSchools.map((school, i) => {
            const BORDER = selectedSchools.includes(school.id) ? `3px solid ${school.color.border}` : 'none'

            return (
              <div
                key={school.id}
                className='border rounded-lg p-3 shadow-sm cursor-pointer mb-2'
                style={{
                  backgroundColor: school.color.background,
                  color: school.color.border,
                  height: 40 + (i === 0 && FIRST_OFFSET) + 'px',
                  maxWidth: '400px',
                  borderLeft: BORDER,
                  borderRight: BORDER,
                  borderBottom: BORDER,
                  borderTop: selectedSchools.includes(school.id)
                    ? i === 0 ? FIRST_OFFSET + 3 + 'px solid' : `3px solid ${school.color.border}`
                    : '',
                  borderRadius: (i === filteredSchools.length - 1) && borderRadius,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                  padding: `${10 + ((!selectedSchools.includes(school.id) && i === 0) && FIRST_OFFSET)}px 10px 10px 10px`,
                  overflow: 'hidden'
                }}
                onClick={(e) => handleClick(e, school.id)}
              >
                <Tooltip title={school.name} placement='right'>
                  <span
                    className='not-selectable-text'
                    style={{
                      color: school.color.text,
                      width: '100%',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      textAlign: 'center',
                      fontSize: '14px',
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical'
                    }}
                  >
                    {school.abbreviation ?? school.name}
                  </span>
                </Tooltip>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default InstitutionSchoolsList
